/**
 * Adult 1–6 only: ICM / interclub championship qualifying (series rules).
 * Adult Beginner through Adult Gold are full USFS adult free skate tests but do not qualify for ICM.
 */
export const ADULT_ICM_QUALIFYING_LEVELS = [
  'Adult 1',
  'Adult 2',
  'Adult 3',
  'Adult 4',
  'Adult 5',
  'Adult 6',
];

/** Full adult test track for profiles, merges, and admin level lists. */
export const ADULT_SKATER_LEVELS = [
  ...ADULT_ICM_QUALIFYING_LEVELS,
  'Adult Beginner',
  'Adult High Beginner',
  'Adult Pre-Bronze',
  'Adult Bronze',
  'Adult Pre-Silver',
  'Adult Silver',
  'Adult Gold',
];

/** Adult free-skate tests past Adult 6 — not eligible for interclub season registration. */
export const ADULT_TRACK_LEVELS_ABOVE_BASIC_SIX = ADULT_SKATER_LEVELS.filter(
  (level) => !ADULT_ICM_QUALIFYING_LEVELS.includes(level)
);

export function isAdultTrackLevelAboveBasicSix(level) {
  return typeof level === 'string' && ADULT_TRACK_LEVELS_ABOVE_BASIC_SIX.includes(level);
}

/** Canonical order for level dropdowns (youth/senior track + adult track). */
export const ORDERED_SKATING_LEVELS = [
  'Snowplow Sam',
  'Basic 1',
  'Basic 2',
  'Basic 3',
  'Basic 4',
  'Basic 5',
  'Basic 6',
  'Aspire 1',
  'Aspire 2',
  'Aspire 3',
  'Aspire 4',
  'Pre-Preliminary',
  'Preliminary',
  'Pre-Juvenile',
  'Juvenile',
  'Intermediate',
  'Novice',
  'Junior',
  'Senior',
  ...ADULT_SKATER_LEVELS,
];

/** Level pickers for skater profiles (Add Skater, onboarding): Adult 1–6 only, not Adult Beginner+. */
export const ORDERED_SKATING_LEVELS_FOR_SKATER_PROFILE = ORDERED_SKATING_LEVELS.filter(
  (level) => !ADULT_TRACK_LEVELS_ABOVE_BASIC_SIX.includes(level)
);

/**
 * Like mergeAdultLevelsIntoSupportedOptions but only re-includes Adult 1–6 for profile dropdowns.
 */
export function mergeAdultIcmLevelsIntoProfileOptions(filteredLevels, fullOrderedProfileLevels) {
  const set = new Set(filteredLevels);
  for (const l of ADULT_ICM_QUALIFYING_LEVELS) {
    set.add(l);
  }
  return fullOrderedProfileLevels.filter((level) => set.has(level));
}

/**
 * After filtering by interclub supportedLevels, re-include full adult track in canonical order.
 */
export function mergeAdultLevelsIntoSupportedOptions(filteredLevels, fullOrderedLevels) {
  const set = new Set(filteredLevels);
  for (const l of ADULT_SKATER_LEVELS) {
    set.add(l);
  }
  return fullOrderedLevels.filter((level) => set.has(level));
}
